export default "__VITE_ASSET__BVk4_VGk__"